"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MWDomains = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("axios"));
var _fetchJsonp = _interopRequireDefault(require("fetch-jsonp"));
var _ciamAuthWebClientLib = require("@eon-funke/ciam-auth-web-client-lib");
var _GlobalErrorHandler = _interopRequireDefault(require("./GlobalErrorHandler"));
var _Router = _interopRequireDefault(require("./Router"));
var _TimeoutWatcher = _interopRequireDefault(require("./TimeoutWatcher"));
var _config = _interopRequireDefault(require("./config/config"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint "@typescript-eslint/no-unused-vars": 0 */
// import { showCCUnauthorizedError } from '../csc/components/CallCenterUnauthorizedError/CallCenterUnauthorizedError';

var MWDomains = exports.MWDomains = {
  account: 'account',
  cicCustomer: 'customer',
  cscCustomer: 'csc'
};
var RestHelper = /*#__PURE__*/function () {
  function RestHelper() {
    (0, _classCallCheck2.default)(this, RestHelper);
  }
  return (0, _createClass2.default)(RestHelper, null, [{
    key: "isCiamLogin",
    value: function isCiamLogin() {
      return _Router.default.getUrlParameter('code');
    }
  }, {
    key: "refreshCiamToken",
    value: function refreshCiamToken() {
      var body = new FormData();
      // grant_type=refresh_token&
      // client_id=3MVG9lKcPoNINVBIPJjdw1J9LLM82HnFVVX19KY1uA5mu0QqEWhqKpoW3svG3XHrXDiCQjK1mdgAvhCscA9GE&client_secret=1955279925675241571&
      // refresh_token=your token here
      body.append('grant_type', 'refresh_token');
      body.append('redirect_uri', window.location.href);
      body.append('refresh_token', _ciamAuthWebClientLib.SessionHandler.getRefreshToken());
      body.append('client_id', _config.default.AEM_CONFIG.SSO.clientId);
      var promise = this.post(_config.default.AEM_CONFIG.SSO.ssoExchangeUrl, body, {}, true, false);
      promise.then(function (response) {
        var _response$data;
        if ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.id_token) {
          _ciamAuthWebClientLib.SessionHandler.setToken(response.data.id_token, _ciamAuthWebClientLib.tokenTypes.ciam);
        }
      });
      return promise;
    }
  }, {
    key: "refreshMiddlewareToken",
    value: function refreshMiddlewareToken() {
      if (_ciamAuthWebClientLib.SessionHandler.isUserAssignedToApp(_ciamAuthWebClientLib.appTypes.cscn)) {
        return this.get("".concat(this.getBaseUrl(MWDomains.cscCustomer), "/grid/cscn-customer-srv/api/root/v0/"));
      }
      if (_ciamAuthWebClientLib.SessionHandler.isUserAssignedToApp(_ciamAuthWebClientLib.appTypes.cic)) {
        return this.get("".concat(this.getBaseUrl(MWDomains.cicCustomer), "/api/root/v0/"));
      }
      return Promise.resolve();
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl(domain) {
      if (!this.baseApiURLs) {
        throw Error('API URL is not set up yet');
      }
      if (!domain) {
        return this.baseApiURLs[MWDomains.cscCustomer];
      }
      return this.baseApiURLs[domain];
    }
  }, {
    key: "initBaseURLs",
    value: function initBaseURLs(urls) {
      this.baseApiURLs = urls;
    }
  }, {
    key: "getAuthHeader",
    value: function getAuthHeader(isCiam) {
      var name = "Bearer";
      if (!_ciamAuthWebClientLib.SessionHandler.getToken(_ciamAuthWebClientLib.tokenTypes.ciam)) {
        return {};
      }
      if (isCiam) {
        return {
          Authorization: "".concat(name, " ").concat(_ciamAuthWebClientLib.SessionHandler.getToken(_ciamAuthWebClientLib.tokenTypes.ciam))
        };
      }
      return {
        'X-Auth-Token': "".concat(name, " ").concat(_ciamAuthWebClientLib.SessionHandler.getToken(_ciamAuthWebClientLib.tokenTypes.ciam))
      };
    }
  }, {
    key: "setConfig",
    value: function setConfig() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var setAuth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var isCiam = (url === null || url === void 0 ? void 0 : url.indexOf(_config.default.AEM_CONFIG.middlewareDomains.account)) !== -1;
      var isCsc = (url === null || url === void 0 ? void 0 : url.indexOf(_config.default.AEM_CONFIG.middlewareDomains.csc)) !== -1;
      var rconfig = config;
      if (!config.headers) {
        rconfig.headers = {};
      }
      if (!config.headers['Content-Type']) {
        rconfig.headers['Content-Type'] = 'application/json';
      }
      if (setAuth) {
        rconfig.headers = _objectSpread(_objectSpread({}, rconfig.headers), this.getAuthHeader(isCiam));
      }
      if (!rconfig.headers['X-Client'] && isCsc) {
        rconfig.headers['X-Client'] = _config.default.CHANNEL_CONFIG.loggedInCsc;
      }
      return _objectSpread({}, rconfig);
    }
  }, {
    key: "errorHandler",
    value: function errorHandler(error) {
      try {
        if (error.response) {
          // The request was made, but the server responded with a status code
          // that falls out of the range of 2xx   );

          if (error.response.status * 1 === 501) {
            // @TODO exception has to be disabled until CSC MW is accepting salesforce token
            //  throw new NoImplementation();
          } else if (error.response.status >= 500) {
            // @TODO exception has to be disabled until CSC MW is accepting salesforce token
            // throw new ServerError();
          }
        } else if (error.message === 'Network Error') {
          // Something happened in setting up the request that triggered an Error
          // @TODO Firefox throwing network error for anything, so for now this will ignored
          // throw new MyNetworkError();
        } else {
          // Something happened in setting up the request that triggered an Error
          // @TODO exception has to be disabled until CSC MW is accepting salesforce token
          // throw new Error(error.message);
        }
      } catch (exception) {
        // @TODO exception has to be disabled until CSC MW is accepting salesforce token
        _GlobalErrorHandler.default.handleException(exception);
      }
    }
  }, {
    key: "get",
    value: function get(url) {
      var _this = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var errorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var timeoutWatcher = new _TimeoutWatcher.default();
      timeoutWatcher.startCounting();
      var request = _axios.default.get(url, this.setConfig(config, auth, url));
      request.then(function (response) {
        timeoutWatcher.responseReceived();
      });
      request.catch(function (error) {
        timeoutWatcher.responseReceived();
        if (errorHandler) {
          _this.errorHandler(error);
        }
      });
      return request;
    }
  }, {
    key: "postFile",
    value: function postFile(url, params) {
      var _this2 = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var timeoutWatcher = new _TimeoutWatcher.default();
      timeoutWatcher.startCounting();
      var request = _axios.default.post(url, params, this.setConfig(config, false, url));
      request.then(function () {
        timeoutWatcher.responseReceived();
      });
      request.catch(function (error) {
        timeoutWatcher.responseReceived();
        _this2.errorHandler(error);
      });
      return request;
    }
  }, {
    key: "post",
    value: function post(url) {
      var _this3 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var errorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      // <-- IE 11 FIX
      // axios.defaults.xsrfHeaderName = 'xsrf_default_overwritten';
      // axios.defaults.headers.post['X-XSRF-TOKEN'] = SessionHandler.getToken();
      // IE 11 FIX -->

      var timeoutWatcher = new _TimeoutWatcher.default();
      timeoutWatcher.startCounting();
      var request = _axios.default.post(url, params, this.setConfig(config, auth, url));
      request.then(function (response) {
        timeoutWatcher.responseReceived();
        return response;
      }).catch(function (response) {
        timeoutWatcher.responseReceived();
      });
      if (errorHandler) {
        request.catch(function (error) {
          _this3.errorHandler(error);
        });
      }
      return request;
    }
  }, {
    key: "put",
    value: function put(url, params) {
      var _this4 = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var errorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var timeoutWatcher = new _TimeoutWatcher.default();
      timeoutWatcher.startCounting();
      var request = _axios.default.put(url, params, this.setConfig(config, auth, url));
      request.then(function (response) {
        timeoutWatcher.responseReceived();
        return response;
      }).catch(function (error) {
        timeoutWatcher.responseReceived();
        _this4.errorHandler(error);
      });
      return request;
    }
  }, {
    key: "patch",
    value: function patch(url, params) {
      var _this5 = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var errorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var timeoutWatcher = new _TimeoutWatcher.default();
      timeoutWatcher.startCounting();
      var request = _axios.default.patch(url, params, this.setConfig(config, auth, url));
      request.catch(function (error) {
        timeoutWatcher.responseReceived();
        _this5.errorHandler(error);
      });
      request.then(function (response) {
        timeoutWatcher.responseReceived();
      });
      return request;
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var _this6 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var errorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var timeoutWatcher = new _TimeoutWatcher.default();
      timeoutWatcher.startCounting();
      var request = _axios.default.delete(url, _objectSpread(_objectSpread({}, this.setConfig(config, auth, url)), {}, {
        data: params
      }));
      request.catch(function (error) {
        timeoutWatcher.responseReceived();
        _this6.errorHandler(error);
      });
      request.then(function (response) {
        timeoutWatcher.responseReceived();
      });
      return request;
    }
  }, {
    key: "getJsonP",
    value: function getJsonP(url) {
      var timeoutWatcher = new _TimeoutWatcher.default();
      timeoutWatcher.startCounting();
      var result = (0, _fetchJsonp.default)(url, {
        timeout: 3000
      });
      result.then(function (response) {
        return response.json();
      }).then(function () {
        timeoutWatcher.responseReceived();
      }).catch(function (ex) {
        timeoutWatcher.responseReceived();
        document.body.innerHTML = "failed: ".concat(ex);
      });
      return result;
    }
  }]);
}();
(0, _defineProperty2.default)(RestHelper, "baseApiURLs", void 0);
var _default = exports.default = RestHelper;